<template>
  <el-config-provider :locale="local">
    <div
      v-if="
        currentPath.path === '/login' ||
        currentPath.path === '/download' ||
        currentPath.path === '/agreement' ||
        currentPath.path === '/selectversion' ||
        currentPath.path === '/joinnewcompany'
      "
    >
      <router-view class="routerView" />
    </div>
    <div v-else class="wrap">
      <my-header />

      <div class="container">
        <my-aside class="aside-box" :currentPath="currentPath"></my-aside>
        <main class="main-box">
          <router-view class="routerView" v-slot="{ Component }" v-if="isRouterAlive">
            <!-- <transition name="el-fade-in-linear" mode="out-in"> -->
            <keep-alive :include="cachedPages">
              <component :is="Component" />
            </keep-alive>
            <!-- </transition> -->
          </router-view>
        </main>
      </div>
    </div>
  </el-config-provider>
</template>

<script setup>
import zhcn from "element-plus/lib/locale/lang/zh-cn";
import { ref, watch, onMounted, computed, onBeforeUnmount, nextTick, provide } from "vue";
import { useRoute, useRouter } from "vue-router";
import myHeader from "@/views/common/header/index.vue";
import myAside from "@/views/common/aside/index.vue";
import { useStore } from "vuex";
const store = useStore();
let route = useRoute();
let router = useRouter();
let currentPath = ref({
  path: "/login"
});
let num = ref(false);
let isRouterAlive = ref(true);
let shareWorker = ref(false);
let local = ref(zhcn);
const cachedPages = computed(() => {
  return store.state.auth.cachedPages;
});
provide("reload");

// 监听
watch(route, (nVal) => {
  currentPath.value = nVal;
});
watch(
  () => store.state.auth.token,
  (newValue) => {
    if (newValue === null) {
      // 发送信息
      shareWorker.value &&
        shareWorker.value.port.postMessage({
          exit: true
        });
    }
  }
);

function reload() {
  isRouterAlive.value = false;
  nextTick(() => {
    isRouterAlive.value = true;
  });
}
const getMessage = async () => {
  if (store.state.auth.userData && !num.value) {
    await store.dispatch("notify/openDataset");
    await store.dispatch("notify/subscribe", store.state.auth.userData);
    num.value = true;
  }
  if (store.state.auth.userData) {
    store.dispatch("notify/getUnReadNotify");
  }
};
function uuidGenerate() {
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(16);
  });
}
//创建SharedWorker多窗口通信
function setShareWorker() {
  // 兼容性判断
  if (!window.SharedWorker) {
    console.log("当前浏览器不支持SharedWorker");
    return;
  }
  shareWorker.value = new SharedWorker("SharedWorker.js");
  // 接收信息
  shareWorker.value.port.onmessage = (e) => {
    if (e.data.exit) {
      store.commit("auth/clear");
      router.replace("/login");
    }
  };
}

onMounted(() => {
  if (!localStorage.getItem("uuid")) {
    store.commit("auth/setUUID", uuidGenerate());
  }
  !window.location.href.includes("/download") && getMessage();
  setShareWorker();
});

onBeforeUnmount(() => {
  shareWorker.value.port.removeEventListener("message");
  shareWorker.value.port.close();
  shareWorker.value = null;
});
</script>

<style lang="scss">
@font-face {
  font-family: "Alibaba-PuHuiTi-R";
  src: url("@/assets/fonts/Alibaba-PuHuiTi-Regular.woff2") format("woff2");
}

html,
body {
  font-family: Alibaba-PuHuiTi-R, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media screen and (max-width: 1440px) {
  .container {
    margin: 0 !important;
  }
}
.wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  .container {
    width: 1440px;
    max-width: 1440px;
    display: flex;
    height: calc(100vh - 71px);
    .aside-box {
      flex: 0 0 200px;
      border-right: 1px solid $border-color-common;
      background-color: #ffffff;
    }
    .main-box {
      margin: 22px 22px 0;
      padding: 20px 24px;
      flex: 1;
      overflow: hidden;
      background-color: #ffffff;
      position: relative;
      box-sizing: border-box;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      .current-com-box {
        min-height: 61px;
        padding-bottom: 20px;
        border-bottom: 1px solid $border-color;
        //   margin-bottom: 20px;
      }
      .routerView {
        overflow: auto;
        height: 100%;
      }
    }
  }
}
</style>
